import React from 'react';
import SelectComponent from './SelectComponent';

const StencilLengthSelect = (props) => {
  const { name } = props;
  return (
    <SelectComponent
      label={props.label}
      name={props.name}
      onChange={(e) => props.onChangeParameter(name, e.target.value)}
      required={props.required}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name] || ''}
      groupName={props.groupName}
      errorMessage={props.errorMessage} />
  );
};

StencilLengthSelect.defaultProps = {
  options: [],
  label: 'Stencil Length',
  name: 'stencil_length',
};

export default StencilLengthSelect;
